import type { ApprovalRequest } from "../../../../api/approvalRequests.service";
import type { UnlinkTestimonialType } from "../../../../api/pipeline.service";
import { getLanguageFlag, getPracticeName } from "../utils";
import styles from "./DetailsColumn.module.css";
import { LawyerContactLink } from "./LawyerContactLink";
import { UnlinkLawyerButton } from "./UnlinkLawyerButton";

type DetailsColumnProps = {
  item: ApprovalRequest;
  onLinkContact?: () => void;
  onUnlinkLawyer?: (testimonialType: UnlinkTestimonialType | undefined) => Promise<void>;
  unlinkDisabled?: boolean;
};

export function DetailsColumn({
  item,
  onLinkContact,
  onUnlinkLawyer,
  unlinkDisabled,
}: DetailsColumnProps) {
  const fName = item.firmName ? `${item.firmName} (${item.firmRef})` : item.firmRef;
  return (
    <div className={styles.detailsColumn}>
      <div className={styles.detailsContent}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Publication:</span>
          <span className={styles.detailValue}>
            {item.publicationName || ""} ({item.edition || ""})
          </span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Firm:</span>
          <span className={styles.detailValue}>{fName}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Region:</span>
          <span className={styles.detailValue}>{item.regionName || "—"}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Practice:</span>
          <span className={styles.detailValue}>{getPracticeName(item)}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Lawyer:</span>
          <span className={styles.detailValue}>
            <LawyerContactLink
              lawyerName={item.lawyerName}
              contactId={item.contactId}
              onLink={onLinkContact}
            />
            {onUnlinkLawyer && (
              <UnlinkLawyerButton
                currentType={item.contentType}
                disabled={unlinkDisabled}
                onConfirm={onUnlinkLawyer}
              />
            )}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Language:</span>
          <span className={styles.detailValue}>
            input: {getLanguageFlag(item.langInput)} output: {getLanguageFlag(item.langOutput)}
          </span>
        </div>
      </div>
    </div>
  );
}
